import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { StyledBar, StyledButton } from "./HamburgerButton.styles";
import { HamburgerButtonProps } from "./HamburgerButton.types";

const HamburgerButton = ({
	onClick,
	className,
	isActive,
	...props
}: HamburgerButtonProps) => {
	const block = new BemIt("HamburgerButton");
	const buttonClassName = addClass(className).after(
		block.mod(isActive ? "open" : "")
	);
	const barClassName = block.el("bar").out;

	return (
		<StyledButton
			id="nav-icon3"
			className={buttonClassName}
			onClick={onClick}
			{...props}
		>
			<StyledBar className={barClassName} />
			<StyledBar className={barClassName} />
			<StyledBar className={barClassName} />
		</StyledButton>
	);
};

export default HamburgerButton;
